const StatusList = [
  { value: "approved" },
  { value: "rejected" },
  { value: "counter" },
];

const DistanceList = [
  { value: 25 },
  { value: 50 },
  { value: 100 },
  { value: 150 },
  { value: 200 },
];

const RadiusFromList = [
  { value: "ORIGIN", label: "Origin" },
  { value: "DESTINATION", label: "Destination" },
  { value: "BOTH", label: "Both" },
];

const RegionList = [
  { value: "west_coast", label: "West Coast" },
  { value: "midwest", label: "Midwest" },
  { value: "southeast", label: "Southeast" },
  { value: "northeast", label: "Northeast" },
];

export { StatusList, DistanceList, RadiusFromList, RegionList };
